import { useContext, useMemo } from 'react'
import { AppContext, AppContextType, AppSettings } from '../AppContext'

export default function useAppSettingsActions() {
    const { dispatch } = useContext(AppContext) as AppContextType

    return useMemo(() => {
        const updateAppSettingItem = (key: keyof AppSettings, value: any, type?: 'number' | 'boolean' | 'string') => {
            let v
            if (type === 'number') {
                v = 0

                if (typeof value === 'boolean') {
                    v = value ? 1 : 0
                } else {
                    // @ts-ignore
                    if (!isNaN(parseInt(value))) {
                        // @ts-ignore
                        v = parseInt(value)
                    }
                }
            } else if (type === 'boolean') {
                v = !!value
            } else if (type === 'string') {
                v = value + ''
            } else {
                v = value
            }

            dispatch({
                type: 'update_app_settings',
                value: { [key]: v },
            })
        }

        return {
            updateAppSettingItem,
        }
    }, [])
}
